export default __webpack_public_path__ + "static/27-9179600e00e4740b61e589a0a823913b.jpg";